var _g, _path, _circle, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13218_34641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 34C66 16.8792 52.1208 3 35 3C17.8792 3 4 16.8792 4 34C4 51.1208 17.8792 65 35 65C52.1208 65 66 51.1208 66 34Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4986 34.6633L14.3708 31.5803C14.115 31.3885 13.9117 31.1877 13.7534 30.9817M22.4986 34.6633L32.2542 38.3637C33.2819 38.7748 35.7075 39.3503 37.1875 38.3637L47.6701 34.5201M22.4986 34.6633V45.7633C26.778 49.2577 37.8034 54.1499 47.6701 45.7633V34.5201M47.6701 34.5201L54.3158 32.0833C55.211 31.755 56.0658 31.1966 56.3553 30.288C56.6219 29.4513 56.605 28.492 55.6875 27.8803L37.1875 20.4803C36.3653 20.0692 34.2275 19.4937 32.2542 20.4803L15.8565 26.6998C14.8772 27.0712 13.8898 27.6076 13.4978 28.5789C13.2014 29.3135 13.1424 30.1865 13.7534 30.9817M13.7534 30.9817V42.0633",
    stroke: "#2D53DA",
    strokeWidth: 1.23333
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.8988,
    cy: 40.2875,
    r: 1.26571,
    fill: "#2D53DA",
    stroke: "#2D53DA",
    strokeWidth: 1.16859
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9669 17.7249L42.5512 17.1406H43.1361L43.7204 17.7249L44.3047 19.4778L45.4733 21.2307L46.6419 21.815L48.3948 22.3993L48.979 22.9836L49.5633 23.5678L48.979 24.1521L46.0576 25.3207L44.889 26.4893L44.3047 27.6579L43.7204 29.4108L43.1361 29.9951H42.5518L41.9675 29.4108L41.3832 27.6579L40.799 26.4893L40.2147 25.905L39.0461 25.3207L37.2926 24.7364C36.3577 24.269 36.5135 23.3731 36.7083 22.9836L37.2926 22.3993H37.8769L40.2141 21.2307L41.3826 19.4778L41.9669 17.7249Z",
    fill: "#ED3241"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8769 29.2709L41.2632 27.3852C41.0882 26.8559 40.7922 26.3742 40.3989 25.9791M41.8769 29.2709L40.3989 25.9791M41.8769 29.2709L41.8797 29.2788C41.9527 29.4839 42.0873 29.6614 42.2652 29.7869C42.4431 29.9124 42.6555 29.9798 42.8732 29.9798C43.0909 29.9798 43.3033 29.9124 43.4811 29.7869C43.659 29.6614 43.7937 29.4839 43.8667 29.2788L43.8694 29.2708L44.483 27.3858C44.6587 26.8579 44.9554 26.3773 45.349 25.9841C45.7427 25.5908 46.2226 25.2948 46.7508 25.1196L48.6368 24.507L48.6449 24.5042C48.8501 24.4312 49.0276 24.2966 49.1531 24.1187C49.2786 23.9408 49.3459 23.7284 49.3459 23.5107C49.3459 23.293 49.2786 23.0806 49.1531 22.9028C49.0276 22.7249 48.8501 22.5902 48.6449 22.5172L48.6331 22.513L48.6211 22.5098L48.592 22.5021L46.7134 21.8922C46.1853 21.717 45.7044 21.4208 45.3108 21.0275C44.9172 20.6343 44.6208 20.1547 44.4451 19.6269L43.8324 17.7409L43.8302 17.7342C43.7579 17.5282 43.6235 17.3497 43.4454 17.2234C43.2674 17.0971 43.0545 17.0293 42.8362 17.0293C42.6179 17.0293 42.405 17.0971 42.2269 17.2234C42.0488 17.3497 41.9144 17.5282 41.8422 17.7342L41.84 17.7407L41.2265 19.6255L41.2112 19.6701C41.0349 20.1852 40.7432 20.6533 40.3585 21.0385C39.9744 21.4232 39.5078 21.7152 38.9939 21.8925L37.1095 22.5046L37.1014 22.5074C36.8963 22.5803 36.7188 22.715 36.5933 22.8929C36.4678 23.0708 36.4004 23.2831 36.4004 23.5009C36.4004 23.7186 36.4678 23.9309 36.5933 24.1088C36.7188 24.2867 36.8963 24.4214 37.1014 24.4944L37.1095 24.4971L38.9953 25.1097M40.3989 25.9791C40.0052 25.5843 39.5253 25.2869 38.9953 25.1097M40.3989 25.9791L38.9953 25.1097",
    stroke: "white",
    strokeWidth: 0.616667
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13218_34641",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13218_34641"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13218_34641",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLms);
export default __webpack_public_path__ + "static/media/LMS.4f5547ad574724b24ee8d71c8a9d7b90.svg";
export { ForwardRef as ReactComponent };